import { InfoHeader } from "@app/components/core/InfoHeader/InfoHeader"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import OrderNavigation from "@app/components/navigation/OrderNavigation"
import ImagePage from "@app/components/pageTypes/ImagePage/ImagePage"
import AnimatedRoute, { AnimationTypes } from "@app/components/routing/AnimatedRoute/AnimatedRoute"
import { useGetLinks, useGetZone } from "@app/store/service/cmsService"
import { appStore } from "@app/store/store"
import { LinkTypes } from "@app/utils/constants"
import { useSelector } from "@tecreation/js-state-react"
import { useEffect } from "react"
import { Navigate, useLocation } from "react-router"
import "./OrderPage.css"

const getLinkUrl = (linkData = {}) => {
	if (appStore.get("core.kioskMode")) return linkData.kioskBaseUrl
	return linkData.baseUrl
}

export default function OrderPage() {
	const location = useLocation()
	const pathName = location.pathname.split("/")[2]
	const { replace } = useCustomNavigation()

	const zoneId = useSelector(state => state.core.zoneId)
	const { data } = useGetZone(zoneId)
	const { data: linkData } = useGetLinks()
	const { title: zoneTitle, openinghoursLabel, openingHoursInfo, openinghoursAdditionalInfo } = data || {}

	useEffect(() => {
		if (!pathName || pathName.length === 0 || pathName === undefined) {
			//If we call order without a specefic path then we have a slide animation because we switch from mainRoute(before) to mainRoute(order) and not to a subroute
			replace("/order/person-types", AnimationTypes.slide)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	//if no subpath then jump to page1
	if (!pathName) {
		return <Navigate to="/order/person-types" replace />
	}

	const renderAdditionalInfo = () => {
		const link = getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData?.links.find(e => e.type === LinkTypes.specialOpeningHours)?.slug
		const split = (openinghoursAdditionalInfo || "").split(/\$\{(hier|here|ici)\}/g)
		return split.map((str, idx) => {
			if (["hier", "here", "ici"].includes(str)) {
				return (
					<a style={{ color: "white" }} key={idx} href={link} target="_blank">
						{str}
					</a>
				)
			}
			return str
		})
	}

	const specialOpeningHours = renderAdditionalInfo() || ""

	return (
		<AnimatedRoute className="h-100">
			{appStore.get("core.kioskMode") === true ? (
				<div className="w-100 flex flex-center h-100">
					<div className="rounded-top-3 rounded-top-lg-0 flex-1 flex flex-column h-100 of-hidden relative container-lg">
						<div className="fill h-100 color-bg-default relative flex">
							<OrderNavigation />
						</div>
					</div>
				</div>
			) : (
				<ImagePage allowUnknownTypes>
					{data ? (
						<InfoHeader ariaLabel={`${zoneTitle} - information`}>
							<h2 className="h-without-default-style">{zoneTitle}</h2>
							<h3 className="f3 mt-2">{openinghoursLabel}</h3>
							<div className="f4">{openingHoursInfo}</div>
							<div className="f4">{specialOpeningHours}</div>
						</InfoHeader>
					) : undefined}

					<div className="rounded-top-3 rounded-top-lg-0 flex-1 flex flex-column h-100 of-hidden relative">
						<div className="fill h-100 color-bg-default relative flex">
							<OrderNavigation />
						</div>
					</div>
				</ImagePage>
			)}
		</AnimatedRoute>
	)
}
